// packages
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { pluralize } from 'journalize';

// internal
import { ELECTION_DAY } from './key-dates';

function init() {
  // const electionDaySlot = document.querySelector('#election-day-countdown');
  // const now = new Date();
  // const daysUntilElectionDay = differenceInCalendarDays(ELECTION_DAY, now);
  // electionDaySlot.textContent = `${daysUntilElectionDay} day${pluralize(
  //   daysUntilElectionDay
  // )}`;
}

export default init;
